(function () {
	
	const MONTHS = {
	  jan: 0, feb: 1, mar: 2, apr: 3, may: 4, jun: 5,
	  jul: 6, aug: 7, sep: 8, oct: 9, nov: 10, dec: 11,
	};

	const ARABIC_MONTHS = {
	  'يناير': 0, 'فبراير': 1, 'مارس': 2, 'ابريل': 3, 'مايو': 4, 'يونيو': 5, 'يونيه': 5,
	  'يوليو': 6, 'يوليه': 6, 'اغسطس': 7, 'سبتمبر': 8, 'اكتوبر': 9, 'نوفمبر': 10, 'ديسمبر': 11,
	  'كانون الثاني': 0, 'شباط': 1, 'اذار': 2, 'نيسان': 3, 'ايار': 4, 'حزيران': 5,
	  'تموز': 6, 'اب': 7, 'ايلول': 8, 'تشرين الاول': 9, 'تشرين الثاني': 10, 'كانون الاول': 11,
	};

	const normalizeArabic = (str) => String(str)
	  .replace(/[٠-٩]/g, (digit) => String(digit.charCodeAt(0) - 0x0660))
	  .replace(/[۰-۹]/g, (digit) => String(digit.charCodeAt(0) - 0x06F0))
	  .replace(/[ً-ْـ]/g, '')
	  .replace(/[أإآ]/g, 'ا')
	  .replace(/،/g, ',')
	  .replace(/\s+/g, ' ')
	  .trim();

	const parseArabicDate = (str) => {
	  const text = normalizeArabic(str);
	  const dayFirst = text.match(/^(\d{1,2}) ([ء-ي ]+?),? (\d{4})(?: (\d{1,2}):(\d{2}))?$/);
	  const monthFirst = text.match(/^([ء-ي ]+?) (\d{1,2}),? (\d{4})(?: (\d{1,2}):(\d{2}))?$/);
	  if (!dayFirst && !monthFirst) return NaN;

	  const day = dayFirst ? dayFirst[1] : monthFirst[2];
	  const monthName = dayFirst ? dayFirst[2] : monthFirst[1];
	  const rest = dayFirst ? dayFirst.slice(3) : monthFirst.slice(3);
	  const month = ARABIC_MONTHS[monthName.trim()];
	  if (month === undefined) return NaN;

	  return new Date(
	    parseInt(rest[0], 10),
	    month,
	    parseInt(day, 10),
	    rest[1] ? parseInt(rest[1], 10) : 0,
	    rest[2] ? parseInt(rest[2], 10) : 0,
	    0
	  ).getTime();
	};

	const parseEndTime = (str) => {
	  if (!str) return NaN;

	  
	  const native = new Date(str).getTime();
	  if (!Number.isNaN(native)) return native;

	  
	  const trimmed = String(str).trim();

	  const cjk = trimmed.match(
	    /^(\d{4})\s*年\s*(\d{1,2})\s*月\s*(\d{1,2})\s*日(?:\s*(\d{1,2})\s*[:时時]\s*(\d{2}))?/
	  );
	  if (cjk) {
	    return new Date(
	      parseInt(cjk[1], 10),
	      parseInt(cjk[2], 10) - 1,
	      parseInt(cjk[3], 10),
	      cjk[4] ? parseInt(cjk[4], 10) : 0,
	      cjk[5] ? parseInt(cjk[5], 10) : 0,
	      0
	    ).getTime();
	  }

	  const arabic = parseArabicDate(trimmed);
	  if (!Number.isNaN(arabic)) return arabic;

	  const match = trimmed.match(
	    /^([a-zA-Z]+)\s+(\d{1,2}),?\s+(\d{4})(?:\s+(\d{1,2}):(\d{2}))?$/
	  );
	  if (!match) return NaN;

	  const month = MONTHS[match[1].slice(0, 3).toLowerCase()];
	  if (month === undefined) return NaN;

	  const day = parseInt(match[2], 10);
	  const year = parseInt(match[3], 10);
	  const hours = match[4] ? parseInt(match[4], 10) : 0;
	  const minutes = match[5] ? parseInt(match[5], 10) : 0;

	  return new Date(year, month, day, hours, minutes, 0).getTime();
	};

	const initTimer = () => {
	  const currentTime = new Date().getTime();
	  const countDownTimer = document.querySelectorAll(".countdown-bar-js");

	  countDownTimer.forEach((timer) => {
		const endDateStr = timer.dataset.date;
		const completedCountdown = timer.dataset.complited;
		const endTime = parseEndTime(endDateStr);

		
		if (Number.isNaN(endTime)) {
		  timer.querySelector(".countdown-bar__days .countdown-bar__number").textContent = '00';
		  timer.querySelector(".countdown-bar__hours .countdown-bar__number").textContent = '00';
		  timer.querySelector(".countdown-bar__min .countdown-bar__number").textContent = '00';
		  timer.querySelector(".countdown-bar__sec .countdown-bar__number").textContent = '00';
		  return;
		}

		const timeLeft = endTime - currentTime;
  
		const days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
		const hours = Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
		const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
		const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);
  
		const formattedDays = String(days).padStart(2, "0");
		const formattedHours = String(hours).padStart(2, "0");
		const formattedMinutes = String(minutes).padStart(2, "0");
		const formattedSeconds = String(seconds).padStart(2, "0");
  
		if (timeLeft < 0 && completedCountdown === "show_zeroes") {
		  clearInterval(initTimer);
  
		  timer.querySelector(".countdown-bar__days .countdown-bar__number").textContent = '00';
		  timer.querySelector(".countdown-bar__hours .countdown-bar__number").textContent = '00';
		  timer.querySelector(".countdown-bar__min .countdown-bar__number").textContent = '00';
		  timer.querySelector(".countdown-bar__sec .countdown-bar__number").textContent = '00';
  
		} else if (timeLeft < 0 && completedCountdown === "hide_coundown") {
		  clearInterval(initTimer);

		  const bannerGroup = timer.closest(".banner-content");
		  if (bannerGroup) {
			bannerGroup.remove();
		  } else if (timer) {
			timer.remove();
		  }
  
		} else if (timeLeft < 0 && completedCountdown === "disable_buttons") {
		  clearInterval(initTimer);
  
		  timer.querySelector(".countdown-bar__days .countdown-bar__number").textContent = '00';
		  timer.querySelector(".countdown-bar__hours .countdown-bar__number").textContent = '00';
		  timer.querySelector(".countdown-bar__min .countdown-bar__number").textContent = '00';
		  timer.querySelector(".countdown-bar__sec .countdown-bar__number").textContent = '00';
  
		  const buyButtonsWrapp = timer.closest('.product');
		  if (buyButtonsWrapp) {
			const buyButtons = buyButtonsWrapp.querySelectorAll('.product-form__buttons button');
			buyButtons.forEach((button) => {
			  button.setAttribute('disabled', true);
			});
		  }
  
		} else {
		  timer.querySelector(".countdown-bar__days .countdown-bar__number").textContent = formattedDays;
		  timer.querySelector(".countdown-bar__hours .countdown-bar__number").textContent = formattedHours;
		  timer.querySelector(".countdown-bar__min .countdown-bar__number").textContent = formattedMinutes;
		  timer.querySelector(".countdown-bar__sec .countdown-bar__number").textContent = formattedSeconds;
		}
	  });
	};
  
	document.addEventListener("shopify:section:load", function () {
	  if (!document.hidden) {
		setInterval(initTimer, 1000);
	  }
	});
  
	if (!document.hidden) {
	  setInterval(initTimer, 1000);
	}
  })();